import { HEX_COLOR_PATTERN, URL_PATTERN } from './portalDetail.constants';
export var jsonToFormData = function (json, formData, parentKey) {
    if (formData === void 0) { formData = null; }
    if (parentKey === void 0) { parentKey = ''; }
    var fd = formData !== null && formData !== void 0 ? formData : new FormData();
    var _loop_1 = function (key) {
        if (!Object.prototype.hasOwnProperty.call(json, key))
            return "continue";
        var nestedKey = parentKey ? "".concat(parentKey, "[").concat(key, "]") : key;
        var value = json[key];
        if (Array.isArray(value)) {
            value.forEach(function (item, index) {
                var arrayKey = "".concat(nestedKey, "[").concat(index, "]");
                if (typeof item === 'object' && !(item instanceof File)) {
                    jsonToFormData(item, fd, arrayKey);
                }
                else {
                    fd.append(arrayKey, item);
                }
            });
        }
        else if (typeof value === 'object' && !(value instanceof File)) {
            jsonToFormData(value, fd, nestedKey);
        }
        else {
            fd.append(nestedKey, value);
        }
    };
    for (var key in json) {
        _loop_1(key);
    }
    return fd;
};
export var REQUIRED_MESSAGE = 'This field is required';
export var validateField = function (name, data, saved) {
    var _a;
    switch (name) {
        case 'defaultActivationCode':
            return !data.IsActivationCodeEnabled && !data.defaultActivationCode ? REQUIRED_MESSAGE : '';
        case 'DefaultInsuranceConsent':
            return data.IsInsuranceOptionEnabled === 1 && data.DefaultInsuranceConsent === '' ? REQUIRED_MESSAGE : '';
        case 'DealerRateAdjustmentType':
            return data.IsDealerRateAdjustmentEnabled === 1 && !data.DealerRateAdjustmentType ? REQUIRED_MESSAGE : '';
        case 'Name':
        case 'PortalType':
        case 'FontStyle':
            return data[name] ? '' : REQUIRED_MESSAGE;
        case 'Domain':
            if (!data.Domain)
                return REQUIRED_MESSAGE;
            return URL_PATTERN.test(data.Domain) ? '' : 'Please enter a valid Domain';
        case 'ProgramIds':
            return ((_a = data.ProgramIds) === null || _a === void 0 ? void 0 : _a.length) ? '' : REQUIRED_MESSAGE;
        case 'PrimaryThemeColor':
        case 'SecondaryThemeColor':
            return data[name] && data[name] !== (saved === null || saved === void 0 ? void 0 : saved[name]) && !HEX_COLOR_PATTERN.test(data[name]) ? 'Enter a valid hex colour, e.g. #20285C' : '';
        default:
            return '';
    }
};
export var parseJsonContent = function (content) {
    if (content === null || content === void 0 ? void 0 : content.json)
        return content.json;
    if (content === null || content === void 0 ? void 0 : content.text) {
        try {
            return JSON.parse(content.text);
        }
        catch (_a) {
            return false;
        }
    }
    return null;
};
var hasKeys = function (value) {
    return Boolean(value) && typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length > 0;
};
export var isFieldConfigValid = function (config) {
    return hasKeys(parseJsonContent(config.nor)) &&
        hasKeys(parseJsonContent(config.loc)) &&
        hasKeys(parseJsonContent(config.sch));
};
export var getFileLabel = function (value) {
    if (!value)
        return '';
    return typeof value === 'string' ? value : value.name || '';
};
